import React from 'react';
import { ShoppingCartIcon as StyledShoppingCartIcon } from './ShoppingCartIcon.styled';

export interface ShoppingCartIconProps {
  className?: string;
}

export function ShoppingCartIcon({ className }: ShoppingCartIconProps) {
  return <StyledShoppingCartIcon className={className} />;
}
